// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quick-edit-components .component-graph-renderer-top{transform:scale(.7);margin-top:-2.5rem}", ""]);
// Exports
module.exports = exports;
